"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.object.freeze");

var _swiper = _interopRequireDefault(require("swiper"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Component: Authors
 * ------------------------------------------------------------------------------
 * A file that contains scripts to function within the authors template.
 *
 * @namespace authors
 */

/**
 * DOM selectors.
 */


var selectors = {
  activeSlide: '[js-active-slide="true"]'
};
/**
 * Create a new authors object.
 */

var _default = function _default() {
  /**
  * DOM node selectors.
  */
  var nodeSelectors = {
    activeSlide: document.querySelector(selectors.activeSlide)
  };
  /**
  * Active slide value.
  */

  var activeIndex = nodeSelectors.activeSlide.getAttribute('data-slide-index');
  /**
  * Create new slider.
  */

  var indexSlider = new _swiper["default"]('.authors-page__list', {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 'auto',
    initialSlide: activeIndex
  });
  /**
   * Initialise component.
   */

  function init() {
    indexSlider.init();
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    init: init
  });
};

exports["default"] = _default;